"use client";
import classNames from "classnames";
import React, { useCallback, useEffect } from "react";
import { BsCheckCircleFill, BsDashCircleFill, BsXLg } from "react-icons/bs";
import { useNotifications } from "states/notifications";
import styles from "./notifications.module.css";
interface ToastCreator {
  type: "success" | "warning";
  text: string;
  id?: string;
}

interface Toast extends ToastCreator {
  id: string;
}

function NotificationsContainer() {
  const { notifications } = useNotifications();
  return (
    <div className={styles.container}>
      {notifications.map((notification) => (
        <ToastDisplay item={notification} key={notification.id} />
      ))}
    </div>
  );
}

export function useToast() {
  const { addNotification } = useNotifications();
  return addNotification;
}

function ToastDisplay({ item }: { item: Toast }) {
  const { removeNotification } = useNotifications();
  const close = useCallback(() => removeNotification(item.id), [item.id, removeNotification]);
  useEffect(() => {
    const id = setTimeout(close, 6000);
    return () => {
      clearTimeout(id);
    };
  }, [close]);
  return (
    <div
      className={classNames({
        [styles.success]: item.type === "success",
        [styles.warning]: item.type === "warning",
      })}>
      <div aria-live="polite" className={classNames("container", styles.toast)}>
        <div></div>
        <p>
          {item.type === "success" ? <BsCheckCircleFill /> : <BsDashCircleFill />}
          {item.text}
        </p>
        <button onClick={close} title="Close notification">
          <BsXLg />
        </button>
      </div>
    </div>
  );
}

export default NotificationsContainer;
